/**
 *  @class
 *  @function PromotionBlocks - based on ProgressBars
 */
if (!customElements.get('promotion-blocks')) {
  class PromotionBlocks extends HTMLElement {
    constructor() {
      super();
      this.blocks = this.querySelectorAll('.promotion-blocks--item');
      this.animatations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.tl = false;
    }
    connectedCallback() {
      if (this.animatations_enabled) {
        this.prepareAnimations();
      }
    }
    disconnectedCallback() {
      if (this.animatations_enabled) {
        this.tl.kill();
      }
    }
    prepareAnimations() {
      let section = this;

      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: "top 70%"
        }
      });

      section.tl
        .fromTo(this.blocks, {opacity: 0, x: -48}, {opacity: 1, x: 0, duration: 0.6, stagger: -0.10, ease: "none"});
        
    }
  }
  customElements.define('promotion-blocks', PromotionBlocks);
}